import React from 'react';

export default function ImageBlockConfig({ data, onChange }) {
  const update = (field, value) => onChange({ ...data, [field]: value });

  return (
    <>
      <div className="adminblog-field">
        <label>Image URL</label>
        <input type="text" value={data.image || ''} onChange={(e) => update('image', e.target.value)} placeholder="Image URL" />
        {data.image && <img src={data.image} alt="Preview" style={{ width: '100%', borderRadius: 6, marginTop: 8, height: 120, objectFit: 'cover' }} />}
      </div>
      <div className="adminblog-field">
        <label>Alt Text</label>
        <input type="text" value={data.alt || ''} onChange={(e) => update('alt', e.target.value)} placeholder="Alternative text" />
      </div>
      <div className="adminblog-field">
        <label>Height</label>
        <select value={data.height || '600px'} onChange={(e) => update('height', e.target.value)}>
          <option value="250px">250px (banner bajo)</option>
          <option value="350px">350px</option>
          <option value="450px">450px</option>
          <option value="600px">600px</option>
          <option value="750px">750px</option>
          <option value="100vh">Full viewport</option>
        </select>
      </div>
      <div className="adminblog-field">
        <label>Overlay</label>
        <select value={data.overlay || 'none'} onChange={(e) => update('overlay', e.target.value)}>
          <option value="none">None</option>
          <option value="gradient-left">Gradient Left</option>
          <option value="gradient-center">Gradient Center</option>
        </select>
      </div>
    </>
  );
}
